/** Bridge lifecycle events (replaces zoid.EVENT) */
export const EVENT = {
  RENDERED: 'RENDERED',
  RESIZE: 'RESIZE',
  DESTROY: 'DESTROY',
  BEFORE_CLOSE: 'BEFORE_CLOSE',
  DISPLAY: 'DISPLAY'
} as const;

/**
 * Lifecycle prop names filtered from dispatch.
 * These are wired to bridge events, NOT forwarded to child.
 *
 * NOTE: onError, onFocus, onLoad are NOT here — they are user-facing
 * props that merchants pass and children call.
 */
export const LIFECYCLE_PROPS = new Set([
  'onClose',
  'onDestroy',
  'onRendered',
  'onRender',
  'onDisplay',
  'onResize',
  'onProps'
]);
